/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */


export const DEFAULT_LOCALE = 'en';

export const APP_STARTUP = 'app/App/APP_STARTUP';
export const APP_CHANGESTATE = 'app/App/APP_CHANGESTATE';
export const APP_NOTIFICATION = 'app/App/APP_NOTIFICATION';

export const APP_CHANGE_FORM = 'app/App/APP_CHANGE_FORM';
export const APP_SET_AUTH = 'app/App/APP_SET_AUTH';
export const APP_SENDING_REQUEST = 'app/App/APP_SENDING_REQUEST';
export const APP_LOGIN_REQUEST = 'app/App/APP_LOGIN_REQUEST';
export const APP_OAUTH_LOGIN_REQUEST = 'app/App/APP_OAUTH_LOGIN_REQUEST';
export const APP_REGISTER_REQUEST = 'app/App/APP_REGISTER_REQUEST';
export const APP_LOGOUT = 'app/App/APP_LOGOUT';
export const APP_REQUEST_ERROR = 'app/App/APP_REQUEST_ERROR';
export const APP_CLEAR_ERROR = 'app/App/APP_CLEAR_ERROR';
export const APP_CHECK_TOKEN = 'app/App/APP_CHECK_TOKEN';
export const APP_REFRESH_TOKEN = 'app/App/APP_REFRESH_TOKEN';

export const SAVE_PROJECT = 'app/App/SAVE_PROJECT';

export const USER_LOGGEDIN = 'app/App/USER_LOGGEDIN';

export const PROJECTS_LOADED = 'app/App/PROJECTS_LOADED';
export const CATEGORIES_LOADED = 'app/App/CATEGORIES_LOADED';

export const PRIMARY_COLOR = '#72c9a5';
export const BACKGROUND_DARK = '#203141';
export const BACKGROUND_DARK2 = '#324659';


// WEBPACK FOOTER //
// ./src/constants.js